import { render } from "./RecencyChart.vue?vue&type=template&id=208bb81b"
import script from "./RecencyChart.vue?vue&type=script&lang=js"
export * from "./RecencyChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__